import { createSelector } from 'reselect';
import { isTrialSelector } from '../../../redux/modules/organization/selectors';
import { isFeatureEnabled } from '../../feature-enablement/featureEnablement';

// Email templates are always enabled for non-trial users
// Trial users can turn it on via a front-end feature flag
export const emailTemplatesEnabledSelector = createSelector(
  isTrialSelector,
  isTrial => isFeatureEnabled('email-templates', {}) || !isTrial
);
